$(window).on('load', function () {
  $(".collection-carousel").slick({
    slidesToShow: 4,
    dots: false,
    prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><circle cx="18" cy="18" r="18" fill="white"/><path d="M21 12L13 18.5L21 25" stroke="#B6637B" stroke-width="2" stroke-linecap="round"/></svg></button>',
    nextArrow: '<button class="slick-arrow slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><circle cx="18" cy="18" r="18" fill="white"/><path d="M21 12L13 18.5L21 25" stroke="#B6637B" stroke-width="2" stroke-linecap="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 2,
        }
      }
    ]
  })
})